import { useState, useRef, useEffect, useLayoutEffect } from 'react';

// Imports MUI components
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

// Imports static data
import SampleData from './../../../constants/storedataredesign.json';
//import StoreData from './../../../constants/storedata.json';
import {
    data_waste,
    /*data_stockout,*/
    data_heatmap,
    data_preplist,
    data_shelflife_default,
    data_shelflife_options,
    data_leadtime_default,
    data_leadtime_options,
    data_prioritization_default,
} from './../../../constants/dataRedesign';

// Imports custom components
import {
    StoreSelect,
    LeadSelect,
    ShelfSelect,
    IngredientSlider,
    BarChart,
    PrepList,
} from '.';

import logo from './logo.png';

const our_waste = [
    [
        [
            Math.floor(2 * (Math.random() * 0.4 + 0.8)),
            Math.floor(4 * (Math.random() * 0.4 + 0.8)),
            Math.floor(6 * (Math.random() * 0.4 + 0.8)),
            Math.floor(8 * (Math.random() * 0.4 + 0.8)),
            Math.floor(10 * (Math.random() * 0.4 + 0.8)),
        ],
        [
            Math.floor(1 * (Math.random() * 0.4 + 0.8)),
            Math.floor(2 * (Math.random() * 0.4 + 0.8)),
            Math.floor(2 * (Math.random() * 0.4 + 0.8)),
            Math.floor(3 * (Math.random() * 0.4 + 0.8)),
            Math.floor(4 * (Math.random() * 0.4 + 0.8)),
        ],
        [
            Math.floor(8 * (Math.random() * 0.4 + 0.8)),
            Math.floor(12 * (Math.random() * 0.4 + 0.8)),
            Math.floor(16 * (Math.random() * 0.4 + 0.8)),
            Math.floor(19 * (Math.random() * 0.4 + 0.8)),
            Math.floor(23 * (Math.random() * 0.4 + 0.8)),
        ],
        [
            Math.floor(5 * (Math.random() * 0.4 + 0.8)),
            Math.floor(6 * (Math.random() * 0.4 + 0.8)),
            Math.floor(7 * (Math.random() * 0.4 + 0.8)),
            Math.floor(9 * (Math.random() * 0.4 + 0.8)),
            Math.floor(11 * (Math.random() * 0.4 + 0.8)),
        ],
        [
            Math.floor(9 * (Math.random() * 0.4 + 0.8)),
            Math.floor(11 * (Math.random() * 0.4 + 0.8)),
            Math.floor(13 * (Math.random() * 0.4 + 0.8)),
            Math.floor(15 * (Math.random() * 0.4 + 0.8)),
            Math.floor(17 * (Math.random() * 0.4 + 0.8)),
        ],
    ],
    [
        [
            Math.floor(2 * (Math.random() * 0.4 + 0.8)),
            Math.floor(4 * (Math.random() * 0.4 + 0.8)),
            Math.floor(6 * (Math.random() * 0.4 + 0.8)),
            Math.floor(8 * (Math.random() * 0.4 + 0.8)),
            Math.floor(10 * (Math.random() * 0.4 + 0.8)),
        ],
        [
            Math.floor(1 * (Math.random() * 0.4 + 0.8)),
            Math.floor(2 * (Math.random() * 0.4 + 0.8)),
            Math.floor(2 * (Math.random() * 0.4 + 0.8)),
            Math.floor(3 * (Math.random() * 0.4 + 0.8)),
            Math.floor(4 * (Math.random() * 0.4 + 0.8)),
        ],
        [
            Math.floor(8 * (Math.random() * 0.4 + 0.8)),
            Math.floor(12 * (Math.random() * 0.4 + 0.8)),
            Math.floor(16 * (Math.random() * 0.4 + 0.8)),
            Math.floor(19 * (Math.random() * 0.4 + 0.8)),
            Math.floor(23 * (Math.random() * 0.4 + 0.8)),
        ],
        [
            Math.floor(5 * (Math.random() * 0.4 + 0.8)),
            Math.floor(6 * (Math.random() * 0.4 + 0.8)),
            Math.floor(7 * (Math.random() * 0.4 + 0.8)),
            Math.floor(9 * (Math.random() * 0.4 + 0.8)),
            Math.floor(11 * (Math.random() * 0.4 + 0.8)),
        ],
        [
            Math.floor(9 * (Math.random() * 0.4 + 0.8)),
            Math.floor(11 * (Math.random() * 0.4 + 0.8)),
            Math.floor(13 * (Math.random() * 0.4 + 0.8)),
            Math.floor(15 * (Math.random() * 0.4 + 0.8)),
            Math.floor(17 * (Math.random() * 0.4 + 0.8)),
        ],
    ],
    [
        [
            Math.floor(2 * (Math.random() * 0.4 + 0.8)),
            Math.floor(4 * (Math.random() * 0.4 + 0.8)),
            Math.floor(6 * (Math.random() * 0.4 + 0.8)),
            Math.floor(8 * (Math.random() * 0.4 + 0.8)),
            Math.floor(10 * (Math.random() * 0.4 + 0.8)),
        ],
        [
            Math.floor(1 * (Math.random() * 0.4 + 0.8)),
            Math.floor(2 * (Math.random() * 0.4 + 0.8)),
            Math.floor(2 * (Math.random() * 0.4 + 0.8)),
            Math.floor(3 * (Math.random() * 0.4 + 0.8)),
            Math.floor(4 * (Math.random() * 0.4 + 0.8)),
        ],
        [
            Math.floor(8 * (Math.random() * 0.4 + 0.8)),
            Math.floor(12 * (Math.random() * 0.4 + 0.8)),
            Math.floor(16 * (Math.random() * 0.4 + 0.8)),
            Math.floor(19 * (Math.random() * 0.4 + 0.8)),
            Math.floor(23 * (Math.random() * 0.4 + 0.8)),
        ],
        [
            Math.floor(5 * (Math.random() * 0.4 + 0.8)),
            Math.floor(6 * (Math.random() * 0.4 + 0.8)),
            Math.floor(7 * (Math.random() * 0.4 + 0.8)),
            Math.floor(9 * (Math.random() * 0.4 + 0.8)),
            Math.floor(11 * (Math.random() * 0.4 + 0.8)),
        ],
        [
            Math.floor(9 * (Math.random() * 0.4 + 0.8)),
            Math.floor(11 * (Math.random() * 0.4 + 0.8)),
            Math.floor(13 * (Math.random() * 0.4 + 0.8)),
            Math.floor(15 * (Math.random() * 0.4 + 0.8)),
            Math.floor(17 * (Math.random() * 0.4 + 0.8)),
        ],
    ],
    [
        [
            Math.floor(2 * (Math.random() * 0.4 + 0.8)),
            Math.floor(4 * (Math.random() * 0.4 + 0.8)),
            Math.floor(6 * (Math.random() * 0.4 + 0.8)),
            Math.floor(8 * (Math.random() * 0.4 + 0.8)),
            Math.floor(10 * (Math.random() * 0.4 + 0.8)),
        ],
        [
            Math.floor(1 * (Math.random() * 0.4 + 0.8)),
            Math.floor(2 * (Math.random() * 0.4 + 0.8)),
            Math.floor(2 * (Math.random() * 0.4 + 0.8)),
            Math.floor(3 * (Math.random() * 0.4 + 0.8)),
            Math.floor(4 * (Math.random() * 0.4 + 0.8)),
        ],
        [
            Math.floor(8 * (Math.random() * 0.4 + 0.8)),
            Math.floor(12 * (Math.random() * 0.4 + 0.8)),
            Math.floor(16 * (Math.random() * 0.4 + 0.8)),
            Math.floor(19 * (Math.random() * 0.4 + 0.8)),
            Math.floor(23 * (Math.random() * 0.4 + 0.8)),
        ],
        [
            Math.floor(5 * (Math.random() * 0.4 + 0.8)),
            Math.floor(6 * (Math.random() * 0.4 + 0.8)),
            Math.floor(7 * (Math.random() * 0.4 + 0.8)),
            Math.floor(9 * (Math.random() * 0.4 + 0.8)),
            Math.floor(11 * (Math.random() * 0.4 + 0.8)),
        ],
        [
            Math.floor(9 * (Math.random() * 0.4 + 0.8)),
            Math.floor(11 * (Math.random() * 0.4 + 0.8)),
            Math.floor(13 * (Math.random() * 0.4 + 0.8)),
            Math.floor(15 * (Math.random() * 0.4 + 0.8)),
            Math.floor(17 * (Math.random() * 0.4 + 0.8)),
        ],
    ],
    [
        [
            Math.floor(2 * (Math.random() * 0.4 + 0.8)),
            Math.floor(4 * (Math.random() * 0.4 + 0.8)),
            Math.floor(6 * (Math.random() * 0.4 + 0.8)),
            Math.floor(8 * (Math.random() * 0.4 + 0.8)),
            Math.floor(10 * (Math.random() * 0.4 + 0.8)),
        ],
        [
            Math.floor(1 * (Math.random() * 0.4 + 0.8)),
            Math.floor(2 * (Math.random() * 0.4 + 0.8)),
            Math.floor(2 * (Math.random() * 0.4 + 0.8)),
            Math.floor(3 * (Math.random() * 0.4 + 0.8)),
            Math.floor(4 * (Math.random() * 0.4 + 0.8)),
        ],
        [
            Math.floor(8 * (Math.random() * 0.4 + 0.8)),
            Math.floor(12 * (Math.random() * 0.4 + 0.8)),
            Math.floor(16 * (Math.random() * 0.4 + 0.8)),
            Math.floor(19 * (Math.random() * 0.4 + 0.8)),
            Math.floor(23 * (Math.random() * 0.4 + 0.8)),
        ],
        [
            Math.floor(5 * (Math.random() * 0.4 + 0.8)),
            Math.floor(6 * (Math.random() * 0.4 + 0.8)),
            Math.floor(7 * (Math.random() * 0.4 + 0.8)),
            Math.floor(9 * (Math.random() * 0.4 + 0.8)),
            Math.floor(11 * (Math.random() * 0.4 + 0.8)),
        ],
        [
            Math.floor(9 * (Math.random() * 0.4 + 0.8)),
            Math.floor(11 * (Math.random() * 0.4 + 0.8)),
            Math.floor(13 * (Math.random() * 0.4 + 0.8)),
            Math.floor(15 * (Math.random() * 0.4 + 0.8)),
            Math.floor(17 * (Math.random() * 0.4 + 0.8)),
        ],
    ],
    [
        [
            Math.floor(2 * (Math.random() * 0.4 + 0.8)),
            Math.floor(4 * (Math.random() * 0.4 + 0.8)),
            Math.floor(6 * (Math.random() * 0.4 + 0.8)),
            Math.floor(8 * (Math.random() * 0.4 + 0.8)),
            Math.floor(10 * (Math.random() * 0.4 + 0.8)),
        ],
        [
            Math.floor(1 * (Math.random() * 0.4 + 0.8)),
            Math.floor(2 * (Math.random() * 0.4 + 0.8)),
            Math.floor(2 * (Math.random() * 0.4 + 0.8)),
            Math.floor(3 * (Math.random() * 0.4 + 0.8)),
            Math.floor(4 * (Math.random() * 0.4 + 0.8)),
        ],
        [
            Math.floor(8 * (Math.random() * 0.4 + 0.8)),
            Math.floor(12 * (Math.random() * 0.4 + 0.8)),
            Math.floor(16 * (Math.random() * 0.4 + 0.8)),
            Math.floor(19 * (Math.random() * 0.4 + 0.8)),
            Math.floor(23 * (Math.random() * 0.4 + 0.8)),
        ],
        [
            Math.floor(5 * (Math.random() * 0.4 + 0.8)),
            Math.floor(6 * (Math.random() * 0.4 + 0.8)),
            Math.floor(7 * (Math.random() * 0.4 + 0.8)),
            Math.floor(9 * (Math.random() * 0.4 + 0.8)),
            Math.floor(11 * (Math.random() * 0.4 + 0.8)),
        ],
        [
            Math.floor(9 * (Math.random() * 0.4 + 0.8)),
            Math.floor(11 * (Math.random() * 0.4 + 0.8)),
            Math.floor(13 * (Math.random() * 0.4 + 0.8)),
            Math.floor(15 * (Math.random() * 0.4 + 0.8)),
            Math.floor(17 * (Math.random() * 0.4 + 0.8)),
        ],
    ],
    [
        [
            Math.floor(2 * (Math.random() * 0.4 + 0.8)),
            Math.floor(4 * (Math.random() * 0.4 + 0.8)),
            Math.floor(6 * (Math.random() * 0.4 + 0.8)),
            Math.floor(8 * (Math.random() * 0.4 + 0.8)),
            Math.floor(10 * (Math.random() * 0.4 + 0.8)),
        ],
        [
            Math.floor(1 * (Math.random() * 0.4 + 0.8)),
            Math.floor(2 * (Math.random() * 0.4 + 0.8)),
            Math.floor(2 * (Math.random() * 0.4 + 0.8)),
            Math.floor(3 * (Math.random() * 0.4 + 0.8)),
            Math.floor(4 * (Math.random() * 0.4 + 0.8)),
        ],
        [
            Math.floor(8 * (Math.random() * 0.4 + 0.8)),
            Math.floor(12 * (Math.random() * 0.4 + 0.8)),
            Math.floor(16 * (Math.random() * 0.4 + 0.8)),
            Math.floor(19 * (Math.random() * 0.4 + 0.8)),
            Math.floor(23 * (Math.random() * 0.4 + 0.8)),
        ],
        [
            Math.floor(5 * (Math.random() * 0.4 + 0.8)),
            Math.floor(6 * (Math.random() * 0.4 + 0.8)),
            Math.floor(7 * (Math.random() * 0.4 + 0.8)),
            Math.floor(9 * (Math.random() * 0.4 + 0.8)),
            Math.floor(11 * (Math.random() * 0.4 + 0.8)),
        ],
        [
            Math.floor(9 * (Math.random() * 0.4 + 0.8)),
            Math.floor(11 * (Math.random() * 0.4 + 0.8)),
            Math.floor(13 * (Math.random() * 0.4 + 0.8)),
            Math.floor(15 * (Math.random() * 0.4 + 0.8)),
            Math.floor(17 * (Math.random() * 0.4 + 0.8)),
        ],
    ],
];

const their_waste = [
    [
        Math.floor(our_waste[0][0][4] * (Math.random() * 0.6 + 1.7)),
        Math.floor(our_waste[0][1][4] * (Math.random() * 0.6 + 1.7)),
        Math.floor(our_waste[0][2][4] * (Math.random() * 0.6 + 1.7)),
        Math.floor(our_waste[0][3][4] * (Math.random() * 0.6 + 1.7)),
        Math.floor(our_waste[0][4][4] * (Math.random() * 0.6 + 1.7)),
    ],
    [
        Math.floor(our_waste[0][0][4] * (Math.random() * 0.6 + 1.7)),
        Math.floor(our_waste[0][1][4] * (Math.random() * 0.6 + 1.7)),
        Math.floor(our_waste[0][2][4] * (Math.random() * 0.6 + 1.7)),
        Math.floor(our_waste[0][3][4] * (Math.random() * 0.6 + 1.7)),
        Math.floor(our_waste[0][4][4] * (Math.random() * 0.6 + 1.7)),
    ],
    [
        Math.floor(our_waste[0][0][4] * (Math.random() * 0.6 + 1.7)),
        Math.floor(our_waste[0][1][4] * (Math.random() * 0.6 + 1.7)),
        Math.floor(our_waste[0][2][4] * (Math.random() * 0.6 + 1.7)),
        Math.floor(our_waste[0][3][4] * (Math.random() * 0.6 + 1.7)),
        Math.floor(our_waste[0][4][4] * (Math.random() * 0.6 + 1.7)),
    ],
    [
        Math.floor(our_waste[0][0][4] * (Math.random() * 0.6 + 1.7)),
        Math.floor(our_waste[0][1][4] * (Math.random() * 0.6 + 1.7)),
        Math.floor(our_waste[0][2][4] * (Math.random() * 0.6 + 1.7)),
        Math.floor(our_waste[0][3][4] * (Math.random() * 0.6 + 1.7)),
        Math.floor(our_waste[0][4][4] * (Math.random() * 0.6 + 1.7)),
    ],
    [
        Math.floor(our_waste[0][0][4] * (Math.random() * 0.6 + 1.7)),
        Math.floor(our_waste[0][1][4] * (Math.random() * 0.6 + 1.7)),
        Math.floor(our_waste[0][2][4] * (Math.random() * 0.6 + 1.7)),
        Math.floor(our_waste[0][3][4] * (Math.random() * 0.6 + 1.7)),
        Math.floor(our_waste[0][4][4] * (Math.random() * 0.6 + 1.7)),
    ],
    [
        Math.floor(our_waste[0][0][4] * (Math.random() * 0.6 + 1.7)),
        Math.floor(our_waste[0][1][4] * (Math.random() * 0.6 + 1.7)),
        Math.floor(our_waste[0][2][4] * (Math.random() * 0.6 + 1.7)),
        Math.floor(our_waste[0][3][4] * (Math.random() * 0.6 + 1.7)),
        Math.floor(our_waste[0][4][4] * (Math.random() * 0.6 + 1.7)),
    ],
    [
        Math.floor(our_waste[0][0][4] * (Math.random() * 0.6 + 1.7)),
        Math.floor(our_waste[0][1][4] * (Math.random() * 0.6 + 1.7)),
        Math.floor(our_waste[0][2][4] * (Math.random() * 0.6 + 1.7)),
        Math.floor(our_waste[0][3][4] * (Math.random() * 0.6 + 1.7)),
        Math.floor(our_waste[0][4][4] * (Math.random() * 0.6 + 1.7)),
    ],
];

const stockout_risks = [
    [
        (4 - Math.random() * 2).toFixed(1),
        (2 - Math.random() * 1).toFixed(1),
        (1 - Math.random() * 1).toFixed(1),
        (0).toFixed(1),
        (0).toFixed(1),
    ],
    [
        (4 - Math.random() * 2).toFixed(1),
        (2 - Math.random() * 1).toFixed(1),
        (1 - Math.random() * 1).toFixed(1),
        (0).toFixed(1),
        (0).toFixed(1),
    ],
    [
        (4 - Math.random() * 2).toFixed(1),
        (2 - Math.random() * 1).toFixed(1),
        (1 - Math.random() * 1).toFixed(1),
        (0).toFixed(1),
        (0).toFixed(1),
    ],
    [
        (4 - Math.random() * 2).toFixed(1),
        (2 - Math.random() * 1).toFixed(1),
        (1 - Math.random() * 1).toFixed(1),
        (0).toFixed(1),
        (0).toFixed(1),
    ],
    [
        (4 - Math.random() * 2).toFixed(1),
        (2 - Math.random() * 1).toFixed(1),
        (1 - Math.random() * 1).toFixed(1),
        (0).toFixed(1),
        (0).toFixed(1),
    ],
];
const hardcode_stockout = [
    [18.9, 13.1, 6.7, 4.1, 2.5],
    [9.7, 4.1, 3.1, 2.0, 1.0],
    [6.6, 4.9, 3.4, 1.9, 1.0],
    [17.2, 12.2, 9.0, 4.4, 1.5],
    [7.5, 5.5, 3.6, 2.6, 1.6],
];

const hardcode_waste = [
    [0.17, 0.27, 0.37, 0.55, 1.02],
    [0.1, 0.21, 0.33, 0.62, 1.29],
    [0.64, 1.43, 2.28, 5.06, 9.97],
    [0.06, 0.12, 0.21, 0.35, 0.64],
    [0.29, 0.5, 0.72, 1.09, 1.96],
];

const daily_preplist = data_preplist();

interface RedesignInterface {
    responsive: boolean;
}

export function Redesign({ responsive }: RedesignInterface) {
    const [sliders, setSliders] = useState(data_prioritization_default);

    const [dialogState, setDialogState] = useState(1);

    const [operatorView, setOperatorView] = useState(false);

    const heightRef = useRef<HTMLDivElement>();
    const heightRef2 = useRef<HTMLDivElement>();

    const [bodyDimentions, setBodyDimensions] = useState({
        width: 0,
        height: 0,
    });
    const [bodyDimentions2, setBodyDimensions2] = useState({
        width: 0,
        height: 0,
    });

    useLayoutEffect(() => {
        if (heightRef.current) {
            setBodyDimensions({
                width: heightRef.current.offsetWidth,
                height: heightRef.current.offsetHeight,
            });
        }
        if (heightRef2.current) {
            setBodyDimensions2({
                width: heightRef2.current.offsetWidth,
                height: heightRef2.current.offsetHeight,
            });
        }
    }, []);

    const setArrayState = (index: number, val: any, func: any, state: any) => {
        let tempArray = state;
        tempArray[index] = val;
        func([...tempArray]);
    };

    const their_sum1 = () => {
        let sum = 0;
        for (const array of their_waste) {
            for (const item of array) {
                sum += item;
            }
        }
        return sum;
    };

    const our_sum1 = () => {
        let tots = data_waste(our_waste, their_waste, sliders);
        let sum = 0;
        for (const item of tots) {
            sum += Number(item.ClearCOGS);
        }
        return sum;
    };

    const their_sum2 = () => {
        return Math.floor(their_sum1() * 52);
    };

    const our_sum2 = () => {
        return Math.floor(our_sum1() * 52);
    };

    return (
        <Box
            width="100%"
            height="100%"
            sx={{
                display: 'flex',
                flexDirection: 'row',
            }}
        >
            <Dialog
                open={dialogState === 1}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                onClose={() => setDialogState(2)}
            >
                <DialogTitle id="alert-dialog-title">
                    {'Welcome to ClearCOGS!'}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Let us show you around your new dashboard. Here, you can
                        control your AI because no one knows your business
                        better than you.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setDialogState(0)}>
                        No thanks...
                    </Button>
                    <Button onClick={() => setDialogState(2)} autoFocus>
                        Lets Get Started!
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={dialogState === 2}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                onClose={() => setDialogState(3)}
                hideBackdrop={true}
            >
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Prioritize your waste and stockout risk with the
                        sliders.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setDialogState(1)}>Back</Button>
                    <Button onClick={() => setDialogState(3)} autoFocus>
                        Continue
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={dialogState === 3}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                onClose={() => setDialogState(4)}
                hideBackdrop={true}
            >
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        See how that effects daily waste in comparison to
                        current levels of waste.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setDialogState(2)}>Back</Button>
                    <Button onClick={() => setDialogState(4)} autoFocus>
                        Continue
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={dialogState === 4}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                onClose={() => setDialogState(0)}
                hideBackdrop={true}
            >
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Here is what is sent to your store managers each day.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setDialogState(3)}>Back</Button>
                    <Button onClick={() => setDialogState(0)} autoFocus>
                        Finish!
                    </Button>
                </DialogActions>
            </Dialog>
            <Box
                width="100%"
                height="100%"
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    gap: responsive ? 2 : 1,
                    backgroundColor: '#F2F2F2',
                }}
            >
                <Paper
                    elevation={4}
                    sx={{
                        width: 'auto',
                        display: 'flex',
                        flexDirection: responsive ? 'row' : 'row-reverse',
                        justifyContent: 'space-between',
                        backgroundColor: '#DDDDDD',
                        padding: responsive ? '0 30px' : '0',
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: responsive ? 'start' : 'end',
                            alignItems: 'center',
                            width: responsive ? '200px' : '100px',
                            marginRight: responsive ? null : '10px',
                        }}
                    >
                        <Button
                            variant="contained"
                            onClick={() => {
                                responsive
                                    ? (window.location.href =
                                          'https://clearcogs.com')
                                    : setOperatorView(!operatorView);
                            }}
                            sx={{
                                height: '30px',
                                backgroundColor:
                                    dialogState === 4 && responsive
                                        ? '#78331E'
                                        : '#F1663C',
                                color:
                                    dialogState === 4 && responsive
                                        ? '#7E7978'
                                        : null,
                                zIndex:
                                    dialogState === 4 && !responsive
                                        ? 40
                                        : null,
                                boxShadow:
                                    dialogState === 4 && !responsive
                                        ? '0 0 0 100vmax rgba(0,0,0,0.5)'
                                        : null,
                            }}
                        >
                            {responsive ? (
                                'Learn More'
                            ) : (
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                    }}
                                >
                                    <Typography
                                        marginBottom="-5px"
                                        sx={{
                                            fontSize: 12,
                                        }}
                                    >
                                        {operatorView ? 'Back To' : 'Operator'}
                                    </Typography>
                                    <Typography
                                        sx={{
                                            fontSize: 12,
                                        }}
                                    >
                                        {operatorView ? 'Dashboard' : 'View'}
                                    </Typography>
                                </Box>
                            )}
                        </Button>
                    </Box>
                    <Box
                        onClick={() => {
                            window.location.href = 'https://clearcogs.com';
                        }}
                        sx={{
                            height: responsive ? '30px' : '15px',
                            width: responsive ? '200px' : '100px',
                            margin: responsive ? '10px' : '15px',
                            backgroundImage: `url(${logo})`,
                            backgroundSize: responsive ? '200px' : '100px',
                        }}
                    />
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: responsive ? 'end' : 'start',
                            alignItems: 'center',
                            width: responsive ? '200px' : '100px',
                            marginLeft: responsive ? null : '10px',
                        }}
                    >
                        <Button
                            variant="contained"
                            onClick={() => {
                                window.location.href =
                                    'https://calendly.com/----1174/30min-with-matt-osa';
                            }}
                            sx={{
                                height: '30px',
                                backgroundColor:
                                    dialogState === 4 && responsive
                                        ? '#78331E'
                                        : '#F1663C',
                                color:
                                    dialogState === 4 && responsive
                                        ? '#7E7978'
                                        : null,
                            }}
                        >
                            {responsive ? (
                                'Schedule a Call'
                            ) : (
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                    }}
                                >
                                    <Typography
                                        marginBottom="-5px"
                                        sx={{
                                            fontSize: 12,
                                        }}
                                    >
                                        Schedule
                                    </Typography>
                                    <Typography
                                        sx={{
                                            fontSize: 12,
                                        }}
                                    >
                                        a Call
                                    </Typography>
                                </Box>
                            )}
                        </Button>
                    </Box>
                </Paper>
                {(responsive || (!responsive && !operatorView)) && (
                    <Box
                        ref={heightRef}
                        sx={{
                            display: 'flex',
                            flexDirection: responsive ? 'row' : 'column',
                            justifyContent: 'space-between',
                            margin: responsive ? '0 30px' : '0 10px',
                            height: '100%',
                        }}
                    >
                        <Box
                            display="flex"
                            flexDirection="column"
                            width={responsive ? 'calc(40% - 20px)' : '100%'}
                            height={
                                responsive
                                    ? `${bodyDimentions.height}px`
                                    : 'auto'
                            }
                        >
                            <Paper
                                elevation={4}
                                sx={{
                                    backgroundColor: '#FFFFFF',
                                    borderRadius: '20px',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    width: 'fill',
                                    height: responsive
                                        ? `${bodyDimentions.height}px`
                                        : '100%',
                                    alignItems: 'center',
                                    zIndex: dialogState === 2 ? 20 : null,
                                    boxShadow:
                                        dialogState === 2
                                            ? '0 0 0 100vmax rgba(0,0,0,0.5)'
                                            : null,
                                }}
                            >
                                <Typography
                                    marginTop={responsive ? '10px' : '5px'}
                                    color="#707070"
                                    marginBottom={responsive ? '-4px' : '-12px'}
                                    sx={{ fontSize: responsive ? 20 : 17 }}
                                >
                                    Set Desired Outcomes
                                </Typography>
                                <Box
                                    height="100%"
                                    width="100%"
                                    margin={responsive ? '10px 0 20px 0' : '0'}
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: responsive
                                            ? 'space-around'
                                            : 'space-between',
                                        marginBottom: responsive
                                            ? '10px'
                                            : '5px',
                                    }}
                                >
                                    <Box
                                        width="100%"
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            justifyContent: 'space-evenly',
                                            marginBottom: responsive
                                                ? '0'
                                                : '-10px',
                                        }}
                                    >
                                        <Box
                                            margin="0 25px"
                                            sx={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                            }}
                                        >
                                            <Typography
                                                color="#707070"
                                                marginBottom="-4px"
                                                sx={{
                                                    fontSize: responsive
                                                        ? 16
                                                        : 13,
                                                }}
                                            >
                                                Daily
                                            </Typography>
                                            <Typography
                                                color="#707070"
                                                marginBottom="-4px"
                                                sx={{
                                                    fontSize: responsive
                                                        ? 16
                                                        : 13,
                                                }}
                                            >
                                                Waste
                                            </Typography>
                                        </Box>

                                        <Box width="170px" height="1px" />

                                        <Box
                                            margin={
                                                responsive ? '0 15px' : '0 20px'
                                            }
                                            sx={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                            }}
                                        >
                                            <Typography
                                                color="#707070"
                                                marginBottom="-4px"
                                                sx={{
                                                    fontSize: responsive
                                                        ? 16
                                                        : 13,
                                                }}
                                            >
                                                Stockout
                                            </Typography>
                                            <Typography
                                                color="#707070"
                                                marginBottom="-4px"
                                                sx={{
                                                    fontSize: responsive
                                                        ? 16
                                                        : 13,
                                                }}
                                            >
                                                Risk
                                            </Typography>
                                        </Box>
                                    </Box>
                                    {SampleData.s7002.map((item, index) => (
                                        <Box
                                            key={index}
                                            sx={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                            }}
                                        >
                                            <Typography
                                                color="#707070"
                                                sx={{
                                                    fontSize: responsive
                                                        ? 16
                                                        : 12,
                                                }}
                                                marginBottom={
                                                    responsive ? '-3px' : '-5px'
                                                }
                                            >
                                                {item.item}
                                            </Typography>
                                            <Box
                                                width="95%"
                                                sx={{
                                                    display: 'flex',
                                                    flexDirection: 'row',
                                                    justifyContent:
                                                        'space-evenly',
                                                    alignItems: 'center',
                                                }}
                                            >
                                                <Typography
                                                    align="center"
                                                    width="60px"
                                                    color="#707070"
                                                    sx={{ fontSize: 16 }}
                                                >
                                                    {`$${
                                                        hardcode_waste[index][
                                                            sliders[index]
                                                        ]
                                                    }`}
                                                </Typography>
                                                <IngredientSlider
                                                    key={index}
                                                    index={index}
                                                    sliders={sliders}
                                                    setArrayState={
                                                        setArrayState
                                                    }
                                                    setSliders={setSliders}
                                                />
                                                <Typography
                                                    align="center"
                                                    width="60px"
                                                    color="#707070"
                                                    sx={{ fontSize: 16 }}
                                                >
                                                    {`${
                                                        hardcode_stockout[
                                                            index
                                                        ][sliders[index]]
                                                    }%`}
                                                </Typography>
                                            </Box>
                                        </Box>
                                    ))}
                                </Box>
                            </Paper>
                        </Box>
                        <Box
                            ref={heightRef2}
                            display="flex"
                            flexDirection="column"
                            width={responsive ? '60%' : '100%'}
                            height={
                                responsive
                                    ? `${bodyDimentions.height}px`
                                    : '100%'
                            }
                            margin={responsive ? '0' : '10px 0'}
                            sx={{ opacity: 0.1 }}
                        >
                            <Paper
                                elevation={4}
                                sx={{
                                    backgroundColor: '#FFFFFF',
                                    borderRadius: '20px',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    width: 'fill',
                                    height: responsive
                                        ? `${bodyDimentions.height - 100}px`
                                        : `${bodyDimentions2.height - 110}px`,
                                    minHeight: responsive
                                        ? `${bodyDimentions.height - 100}px`
                                        : `${bodyDimentions2.height - 110}px`,
                                    alignItems: 'center',
                                    zIndex: dialogState === 3 ? 20 : null,
                                    boxShadow:
                                        dialogState === 3
                                            ? '0 0 0 100vmax rgba(0,0,0,0.5)'
                                            : null,
                                }}
                            >
                                <Typography
                                    color="#707070"
                                    marginTop="10px"
                                    sx={{ fontSize: responsive ? 20 : 17 }}
                                >
                                    Daily Waste Costs
                                </Typography>
                                {data_waste && (
                                    <BarChart
                                        data={data_waste(
                                            our_waste,
                                            their_waste,
                                            sliders
                                        )}
                                        format=">-$0.0~f"
                                        responsive={
                                            dialogState === 4 && responsive
                                        }
                                    />
                                )}
                            </Paper>
                            <Paper
                                elevation={4}
                                sx={{
                                    marginTop: responsive ? '20px' : '10px',
                                    backgroundColor: '#FFFFFF',
                                    borderRadius: '20px',
                                    display: 'flex',
                                    flexDirection: 'row',
                                    width: 'fill',
                                    height: responsive ? '100%' : '100px',
                                    alignItems: 'center',
                                    zIndex: dialogState === 3 ? 20 : null,
                                }}
                            >
                                <Box
                                    width="100%"
                                    height="100%"
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        justifyContent: 'space-evenly',
                                    }}
                                >
                                    <Box
                                        width={responsive ? '43%' : '38%'}
                                        height="80%"
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            justifyContent: 'space-evenly',
                                        }}
                                    >
                                        <Box
                                            width="100%"
                                            sx={{
                                                display: 'flex',
                                                flexDirection: 'row',
                                                alignItems: 'center',
                                                justifyContent: 'space-between',
                                            }}
                                        >
                                            <Typography
                                                align="left"
                                                color="#707070"
                                                sx={{
                                                    fontSize: responsive
                                                        ? 15
                                                        : 14,
                                                }}
                                            >
                                                Weekly Loss:
                                            </Typography>
                                            <Typography
                                                align="right"
                                                color="#707070"
                                                sx={{
                                                    fontSize: responsive
                                                        ? 15
                                                        : 14,
                                                }}
                                            >
                                                {'$' + String(their_sum1())}
                                            </Typography>
                                        </Box>
                                        <Box
                                            width="100%"
                                            sx={{
                                                display: 'flex',
                                                flexDirection: 'row',
                                                alignItems: 'center',
                                                justifyContent: 'space-between',
                                            }}
                                        >
                                            {responsive ? (
                                                <Typography
                                                    align="left"
                                                    color="#707070"
                                                    sx={{ fontSize: 15 }}
                                                >
                                                    ClearCOGS Weekly Loss:
                                                </Typography>
                                            ) : (
                                                <Box
                                                    sx={{
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        alignItems: 'start',
                                                        justifyContent:
                                                            'center',
                                                    }}
                                                >
                                                    <Typography
                                                        align="left"
                                                        color="#707070"
                                                        sx={{
                                                            fontSize: 14,
                                                            marginBottom:
                                                                '-7px',
                                                        }}
                                                    >
                                                        ClearCOGS
                                                    </Typography>
                                                    <Typography
                                                        align="left"
                                                        color="#707070"
                                                        sx={{
                                                            fontSize: 14,
                                                        }}
                                                    >
                                                        Weekly Loss:
                                                    </Typography>
                                                </Box>
                                            )}
                                            <Typography
                                                align="right"
                                                color="#707070"
                                                sx={{
                                                    fontSize: responsive
                                                        ? 15
                                                        : 14,
                                                }}
                                            >
                                                {'$' + String(our_sum1())}
                                            </Typography>
                                        </Box>
                                    </Box>
                                    <Box
                                        width={responsive ? '43%' : '42%'}
                                        height="80%"
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            justifyContent: 'space-evenly',
                                        }}
                                    >
                                        <Box
                                            width="100%"
                                            sx={{
                                                display: 'flex',
                                                flexDirection: 'row',
                                                alignItems: 'center',
                                                justifyContent: 'space-between',
                                            }}
                                        >
                                            <Typography
                                                align="left"
                                                color="#707070"
                                                sx={{
                                                    fontSize: responsive
                                                        ? 15
                                                        : 14,
                                                }}
                                            >
                                                Yearly Loss:
                                            </Typography>
                                            <Typography
                                                align="right"
                                                color="#505050"
                                                sx={{
                                                    fontSize: responsive
                                                        ? 15
                                                        : 14,
                                                    fontWeight: '700',
                                                }}
                                            >
                                                {'$' + String(their_sum2())}
                                            </Typography>
                                        </Box>
                                        <Box
                                            width="100%"
                                            sx={{
                                                display: 'flex',
                                                flexDirection: 'row',
                                                alignItems: 'center',
                                                justifyContent: 'space-between',
                                            }}
                                        >
                                            {responsive ? (
                                                <Typography
                                                    align="left"
                                                    color="#707070"
                                                    sx={{
                                                        fontSize: 15,
                                                    }}
                                                >
                                                    ClearCOGS Yearly Loss:
                                                </Typography>
                                            ) : (
                                                <Box
                                                    sx={{
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        alignItems: 'start',
                                                        justifyContent:
                                                            'center',
                                                    }}
                                                >
                                                    <Typography
                                                        align="left"
                                                        color="#707070"
                                                        sx={{
                                                            fontSize: 14,
                                                            marginBottom:
                                                                '-7px',
                                                        }}
                                                    >
                                                        ClearCOGS
                                                    </Typography>
                                                    <Typography
                                                        align="left"
                                                        color="#707070"
                                                        sx={{
                                                            fontSize: 14,
                                                        }}
                                                    >
                                                        Yearly Loss:
                                                    </Typography>
                                                </Box>
                                            )}
                                            <Typography
                                                align="right"
                                                color="#505050"
                                                sx={{
                                                    fontSize: responsive
                                                        ? 15
                                                        : 14,
                                                    fontWeight: '700',
                                                }}
                                            >
                                                {'$' + String(our_sum2())}
                                            </Typography>
                                        </Box>
                                    </Box>
                                </Box>
                            </Paper>
                        </Box>
                    </Box>
                )}
                {responsive && (
                    <Box
                        sx={{
                            margin: '0 30px 30px 30px',
                            opacity: 0.1,
                        }}
                    >
                        <Paper
                            elevation={4}
                            sx={{
                                backgroundColor: '#DAF0FF',
                                borderRadius: '20px',
                                display: 'flex',
                                flexDirection: 'column',
                                width: 'fill',
                                height: '170px',
                                alignItems: 'center',
                                zIndex: dialogState === 4 ? 40 : null,
                                boxShadow:
                                    dialogState === 4
                                        ? '0 0 0 100vmax rgba(0,0,0,0.5)'
                                        : null,
                            }}
                        >
                            <Typography
                                color="#707070"
                                marginTop="10px"
                                sx={{ fontSize: 20 }}
                            >
                                PAR's
                            </Typography>
                            <Box width="100%" height="100%">
                                <Box
                                    width="100%"
                                    height="40%"
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        justifyContent: 'space-evenly',
                                    }}
                                >
                                    <Box sx={{ width: '100px' }} />
                                    {SampleData.s7002.map((item, index) => {
                                        return (
                                            <Box
                                                key={index}
                                                width="100px"
                                                sx={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                }}
                                            >
                                                <Typography
                                                    color="#707070"
                                                    align="center"
                                                    sx={{
                                                        fontSize: 16,
                                                    }}
                                                >
                                                    {item.item}
                                                </Typography>
                                            </Box>
                                        );
                                    })}
                                </Box>
                                <Divider variant="middle" />
                                <Box
                                    width="100%"
                                    height="25%"
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        justifyContent: 'space-evenly',
                                    }}
                                >
                                    <Box sx={{ width: '100px' }}>
                                        <Typography
                                            color="#707070"
                                            align="left"
                                            sx={{
                                                fontSize: 16,
                                                width: '70px',
                                            }}
                                        >
                                            Today
                                        </Typography>
                                    </Box>
                                    {SampleData.s7002.map((item, index) => {
                                        return (
                                            <Typography
                                                key={index}
                                                color="#707070"
                                                align="center"
                                                sx={{
                                                    fontSize: 16,
                                                    width: '100px',
                                                }}
                                            >
                                                {
                                                    daily_preplist[0][index][
                                                        sliders[index]
                                                    ]
                                                }
                                            </Typography>
                                        );
                                    })}
                                </Box>
                                <Divider variant="middle" />
                                <Box
                                    width="100%"
                                    height="25%"
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        justifyContent: 'space-evenly',
                                    }}
                                >
                                    <Box sx={{ width: '100px' }}>
                                        <Typography
                                            color="#707070"
                                            align="left"
                                            sx={{
                                                fontSize: 16,
                                                width: '70px',
                                            }}
                                        >
                                            Tomorrow
                                        </Typography>
                                    </Box>
                                    {SampleData.s7002.map((item, index) => {
                                        return (
                                            <Typography
                                                key={index}
                                                color="#707070"
                                                align="center"
                                                sx={{
                                                    fontSize: 16,
                                                    width: '100px',
                                                }}
                                            >
                                                {
                                                    daily_preplist[1][index][
                                                        sliders[index]
                                                    ]
                                                }
                                            </Typography>
                                        );
                                    })}
                                </Box>
                            </Box>
                        </Paper>
                    </Box>
                )}
                {!responsive && operatorView && (
                    <Box
                        sx={{
                            margin: '10px',
                            height: '100%',
                        }}
                    >
                        <Paper
                            elevation={4}
                            sx={{
                                backgroundColor: '#DAF0FF',
                                borderRadius: '20px',
                                display: 'flex',
                                flexDirection: 'column',
                                width: 'fill',
                                padding: '10px',
                                alignItems: 'center',
                                zIndex: dialogState === 4 ? 40 : null,
                                boxShadow:
                                    dialogState === 4
                                        ? '0 0 0 100vmax rgba(0,0,0,0.5)'
                                        : null,
                            }}
                        >
                            <Typography
                                color="#707070"
                                margin="10px 0"
                                sx={{ fontSize: 20 }}
                            >
                                PAR's
                            </Typography>
                            <Box width="100%" height="100%">
                                <Box
                                    width="100%"
                                    height="30px"
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        justifyContent: 'space-evenly',
                                    }}
                                >
                                    <Box sx={{ width: '100px' }} />
                                    <Box
                                        width="100px"
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                        }}
                                    >
                                        <Typography
                                            color="#707070"
                                            align="center"
                                            sx={{
                                                fontSize: 16,
                                            }}
                                        >
                                            Today
                                        </Typography>
                                    </Box>
                                    <Box
                                        width="100px"
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                        }}
                                    >
                                        <Typography
                                            color="#707070"
                                            align="center"
                                            sx={{
                                                fontSize: 16,
                                            }}
                                        >
                                            Tomorrow
                                        </Typography>
                                    </Box>
                                </Box>

                                {SampleData.s7002.map((item, index) => {
                                    return (
                                        <Box>
                                            <Divider variant="middle" />
                                            <Box
                                                key={index}
                                                width="100%"
                                                height="60px"
                                                sx={{
                                                    display: 'flex',
                                                    flexDirection: 'row',
                                                    alignItems: 'center',
                                                    justifyContent:
                                                        'space-evenly',
                                                }}
                                            >
                                                <Box
                                                    width="100px"
                                                    sx={{
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        alignItems: 'center',
                                                        justifyContent:
                                                            'center',
                                                    }}
                                                >
                                                    <Typography
                                                        color="#707070"
                                                        align="center"
                                                        sx={{
                                                            fontSize: 16,
                                                        }}
                                                    >
                                                        {item.item}
                                                    </Typography>
                                                </Box>
                                                <Box
                                                    width="100px"
                                                    sx={{
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        alignItems: 'center',
                                                        justifyContent:
                                                            'center',
                                                    }}
                                                >
                                                    <Typography
                                                        color="#707070"
                                                        align="center"
                                                        sx={{
                                                            fontSize: 16,
                                                        }}
                                                    >
                                                        {
                                                            daily_preplist[0][
                                                                index
                                                            ][sliders[index]]
                                                        }
                                                    </Typography>
                                                </Box>
                                                <Box
                                                    width="100px"
                                                    sx={{
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        alignItems: 'center',
                                                        justifyContent:
                                                            'center',
                                                    }}
                                                >
                                                    <Typography
                                                        color="#707070"
                                                        align="center"
                                                        sx={{
                                                            fontSize: 16,
                                                        }}
                                                    >
                                                        {
                                                            daily_preplist[1][
                                                                index
                                                            ][sliders[index]]
                                                        }
                                                    </Typography>
                                                </Box>
                                            </Box>
                                        </Box>
                                    );
                                })}
                            </Box>
                        </Paper>
                    </Box>
                )}
            </Box>
        </Box>
    );
}
